import { IScenarioStatisticsResponse } from '@kurtosys/types/portal/index.js';
import { ScenarioStatisticShortcut } from '@kurtosys/types/query/scenarioStatistics/ScenarioStatisticShortcut.js';
import {
	IQueryShortcutOptions,
	ShortcutType,
	TRootOptionsShortcutFnReturn,
} from '@kurtosys/types/query/scenarioStatistics/shortcuts/index.js';

import { ScenarioStatisticQuery } from '../../queries/ScenarioStatisticQuery.js';

export class ShortcutBase {
	public key: ScenarioStatisticShortcut;
	public type: ShortcutType;
	public scenarioStatisticQuery: ScenarioStatisticQuery;

	public getRootOptions(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		shortcutOptions: IQueryShortcutOptions,
	): TRootOptionsShortcutFnReturn {
		return {};
	}

	getDirectResponse(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		shortcutOptions: IQueryShortcutOptions,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		scenarioStatistics: IScenarioStatisticsResponse,
	): any {
		return undefined;
	}
	constructor(key: ScenarioStatisticShortcut, type: ShortcutType, scenarioStatisticQuery: ScenarioStatisticQuery) {
		this.key = key;
		this.type = type;
		this.scenarioStatisticQuery = scenarioStatisticQuery;
	}
}
